// @flow
import { I18n } from 'aws-amplify';

export default function translateDaysString(value: string): string {
    return value ? value.split(',').map(day => I18n.get(day)).join(', ') : '';
}
